import { O2_ENV_GROUP, YETTEL_ENV_GROUP } from 'consts';

export function isO2EnvGroup(partnerID: number | undefined) {
  return !!partnerID && O2_ENV_GROUP.includes(partnerID);
}

export function isYettelEnvGroup(partnerID: number | undefined) {
  return !!partnerID && YETTEL_ENV_GROUP.includes(partnerID);
}
